<template>
  <div class="my-reward">
    <kaer-page
      :props="{
        headerConfig: {
          title: '我的红包',
          immersion: false,
          navEnvs: ['app']
        }
      }"
    >
      <div
        class="my-reward-page"
        :style="{
          height: env.inAPP ? `calc(100vh - ${headerPaddingTop}px` : '100vh'
        }"
      >
        <div class="my-reward-header">
          <div class="my-reward-money-wrap">
            <div class="my-reward-money">
              <span class="unit">¥</span>
              {{ detail.grantedAmount }}
            </div>
            <p class="money-desc">累计已获得红包</p>
          </div>
          <div class="my-reward-use-wrap">
            <div class="my-reward-use" @click="toUse">去使用</div>
          </div>
        </div>
        <div class="my-reward-container">
          <div class="container-body">
            <div class="container-body-header">
              <div
                :class="['body-header-item', active === index && 'body-header-item-active']"
                v-for="(item, index) in list"
                :key="index"
                @click="handleChangeActive(index)"
              >
                <div class="header-item-title">{{ item.title }}</div>
                <div class="header-item-desc">{{ `${detail[item.descKey] || 0}${item.unit}` }}</div>
                <div class="item-active-line"></div>
              </div>
            </div>
            <van-divider style="margin: 0" />
            <div class="container-body-main">
              <div class="container-tips" v-if="!!list[active].tips">{{ list[active].tips }}</div>
              <van-empty
                v-if="list[active].finished && !list[active].list.length"
                :image="require('@/assets/reward/empty-bg.png')"
                :description="list[active].emptyDesc"
              />
              <van-list
                style="background-color: #fff"
                v-else
                v-model="list[active].loading"
                :finished="list[active].finished"
                :error.sync="list[active].error"
                error-text="请求失败，点击重试"
                finished-text="已经到底了"
                @load="getList"
              >
                <RecordCard
                  v-for="(row, i) in list[active].list"
                  :key="i"
                  :row="row"
                  :queryType="list[active].queryType"
                />
              </van-list>
            </div>
          </div>
        </div>
      </div>
    </kaer-page>
  </div>
</template>

<script>
import { inviteAwardTotalDetailGet, inviteAwardRecordGet } from '@/api';
import KaerPage from '@/components/page/index.vue';
import RecordCard from '@/components/record-card';
import { staticUrl } from '@/config';

export default {
  name: 'my-reward',
  components: { KaerPage, RecordCard },
  data() {
    return {
      detail: {
        money: 0,
        onTheWay: 0,
        waitGrantAmount: 0,
        grantedAmount: 0,
        invalid: 0
      },
      active: 0,
      list: [
        {
          title: '在路上',
          descKey: 'onTheWay',
          queryType: 3,
          unit: '元',
          tips: '邀请的用户在活动时间内用券下单，预计带来的奖励',
          emptyDesc: '暂时还没有邀请好友领红包',
          loading: false,
          finished: false,
          error: false,
          pageNo: 1,
          pageSize: 20,
          list: []
        },
        {
          title: '待到账',
          descKey: 'waitGrantAmount',
          queryType: 0,
          unit: '元',
          tips: '邀请的下单用户在确认收货后，奖励红包即时到账~',
          emptyDesc: '暂时没有待到账的红包',
          loading: false,
          finished: false,
          error: false,
          pageNo: 1,
          pageSize: 20,
          list: []
        },
        {
          title: '已获得',
          descKey: 'grantedAmount',
          queryType: 1,
          unit: '元',
          emptyDesc: '空空如也，快去邀请赚红包吧～',
          loading: false,
          finished: false,
          error: false,
          pageNo: 1,
          pageSize: 20,
          list: []
        },
        {
          title: '已失效',
          descKey: 'invalid',
          queryType: 2,
          unit: '份',
          emptyDesc: '暂时没有失效记录',
          loading: false,
          finished: false,
          error: false,
          pageNo: 1,
          pageSize: 20,
          list: []
        }
      ]
    };
  },
  computed: {
    headerPaddingTop() {
      return this.adapt.getPaddingTop() + 44;
    },
    activityId() {
      return this.$route.query.activityId;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name) {
      next();
    } else {
      next('/');
    }
  },
  created() {
    const shareConfig = sessionStorage.getItem('shareConfig');
    this.adapt.setTitle('我的红包');
    if (shareConfig) {
      this.$store.commit('setShareConfig', JSON.parse(shareConfig));
    }
  },
  mounted() {
    this.getTotal();
  },
  methods: {
    handleChangeActive(index) {
      if (this.active === index) return;
      this.active = index;
    },
    async getTotal() {
      const params = {
        activityId: this.activityId,
        bizId: 'C_TERMINAL',
        activityType: this.$route.query.activityType
      };
      const res = await inviteAwardTotalDetailGet(params);
      this.detail = res;
    },
    async getList() {
      const current = this.list[this.active];

      const params = {
        pageNo: current.pageNo,
        pageSize: current.pageSize,
        activityId: this.activityId,
        bizId: 'C_TERMINAL',
        queryType: current.queryType,
        activityType: this.$route.query.activityType
      };
      console.log(params);

      this.ZYToast.setOnceConfig({ noToast: true });

      try {
        const res = await inviteAwardRecordGet(params);
        this.ZYToast.clearOnceConfig();
        current.list = current.list.concat(res);

        if (res.length < params.pageSize) {
          current.finished = true;
          return;
        }

        current.pageNo += 1;
        current.loading = false;
      } catch (error) {
        this.ZYToast.clearOnceConfig();
        current.loading = false;
        current.error = true;
        console.log(error, current.error);
      }
    },
    toUse() {
      this.adapt.open(`${staticUrl}f2e/zmall/index.html#/coupon-list`);
    }
  }
};
</script>

<style lang="scss" scoped>
.my-reward {
  background-color: #f5f5f5;
  min-height: 100vh;
  .my-reward-page {
    display: flex;
    flex-direction: column;
    background-image: url('~@/assets/reward/reward-bg.png');
    background-size: 100%;
    background-repeat: no-repeat;
    .my-reward-header {
      display: flex;
      padding: 20px 24px;
      justify-content: space-between;
      align-items: center;
      .my-reward-money-wrap {
        color: #fff;
        .my-reward-money {
          font-size: 32px;
          font-weight: 500;
          .unit {
            font-size: 16px;
          }
        }
        .money-desc {
          font-size: 12px;
          margin-top: 6px;
        }
      }
      .my-reward-use-wrap {
        position: relative;
        .my-reward-use {
          width: 80px;
          height: 24px;
          border-radius: 24px;
          text-align: center;
          line-height: 24px;
          font-size: 12px;
          color: #fff;
        }
        .my-reward-use::after {
          content: ' ';
          position: absolute;
          border: 1px solid #fff;
          border-radius: 24px;
          transform: scale(0.5);
          top: -50%;
          left: -50%;
          bottom: -50%;
          right: -50%;
        }
      }
    }
    .my-reward-container {
      padding: 12px;
      padding-top: 0px;
      flex: 1;
      overflow: hidden;
      .container-body {
        height: 100%;
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .container-body-header {
          height: 64px;
          display: flex;
          background: #fff;
          .body-header-item {
            flex: 1;
            color: #8c8c8c;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .header-item-title {
              font-size: 16px;
              margin-top: 16px;
              line-height: 16px;
            }
            .header-item-desc {
              font-size: 12px;
              font-weight: 500;
              margin-top: 6px;
            }
          }
          .body-header-item-active {
            .header-item-title {
              color: #262626;
              font-weight: 500;
            }
            .header-item-desc {
              color: #f65425;
            }
            .item-active-line {
              width: 20px;
              height: 3px;
              border-radius: 1.5px;
              background-color: #f65425;
              position: absolute;
              bottom: 0;
              left: calc(50% - 10px);
            }
          }
        }
        .container-body-main {
          overflow: scroll;
          flex: 1;
          border-radius: 8px;
          .container-tips {
            margin: 12px;
            background-color: #f5f5f5;
            border-radius: 8px;
            padding: 5px 12px;
            line-height: 18px;
            color: #8c8c8c;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
